import React, { useState, useEffect } from "react";
import axios from "axios";
import './App.css';

const API_URL = "";

function App() {
  // Auth states
  const [token, setToken] = useState(localStorage.getItem("token") || "");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [authError, setAuthError] = useState("");
  const [isRegister, setIsRegister] = useState(false);

  // Demo mode state
  const [demoMode, setDemoMode] = useState(false);

  // To-do states
  const [input, setInput] = useState("");
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(false);

  // --- AUTH HANDLERS ---

  const handleAuth = async (e) => {
    e.preventDefault();
    setAuthError("");
    try {
      const url = isRegister ? "/api/register" : "/api/login";
      const res = await axios.post(API_URL + url, { email, password });
      if (isRegister) {
        alert("Registration successful! Please login.");
        setIsRegister(false);
      } else {
        setToken(res.data.token);
        localStorage.setItem("token", res.data.token);
        setEmail("");
        setPassword("");
      }
    } catch (err) {
      setAuthError(err.response?.data?.error || "Auth failed");
    }
  };

  const handleLogout = () => {
    setToken("");
    localStorage.removeItem("token");
    setTasks([]);
  };

  // --- TASK HANDLERS ---

  // Only fetch tasks from server if not in demo mode
  useEffect(() => {
    if (!token || demoMode) return;
    setLoading(true);
    axios
      .get(API_URL + "/api/tasks", {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => setTasks(res.data))
      .catch(err => console.error("Error fetching tasks:", err))
      .finally(() => setLoading(false));
  }, [token, demoMode]);

  const addTask = () => {
    if (input.trim() === "") return;
    if (demoMode) {
      setTasks([...tasks, { id: Date.now(), text: input }]);
      setInput("");
    } else if (token) {
      axios
        .post(API_URL + "/api/tasks", { text: input }, {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then(res => {
          setTasks([...tasks, res.data]);
          setInput("");
        })
        .catch(err => console.error("Error adding task:", err));
    }
  };

  const deleteTask = (id) => {
    if (demoMode) {
      setTasks(tasks.filter(task => task.id !== id));
    } else if (token) {
      axios
        .delete(`${API_URL}/api/tasks/${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then(() => setTasks(tasks.filter(task => task.id !== id)))
        .catch(err => console.error("Error deleting task:", err));
    }
  };

  // --- RENDER ---

  // Landing page (Login/register + demo button)
  if (!token && !demoMode) {
    // Show login/register form
    return (
      <div className="app-container">
        <h1 style={{ marginTop: 0, color: "#2465c7", fontSize: "2.1rem" }}>Welcome to the world's simplest To-Do List! 😄</h1>
        <p style={{ color: "#333", marginTop: "0.4em", marginBottom: "1.8em" }}>
          Just log in or register to access your very private to-do list!
          Your tasks are saved until completion!
          Once a task is complete, just delete it and forget about it!
          Not convinced? Try our demo mode before signing up!
        </p>
        <h2>{isRegister ? "Register" : "Login"}</h2>
        <form onSubmit={handleAuth}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            required
            onChange={e => setEmail(e.target.value)}
          /><br />
          <input
            type="password"
            placeholder="Password"
            value={password}
            required
            onChange={e => setPassword(e.target.value)}
          /><br />
          <button type="submit" className="full-width-btn">{isRegister ? "Register" : "Login"}</button>
        </form>
        <button className="full-width-btn" onClick={() => setIsRegister(!isRegister)}>
          {isRegister ? "Already have an account? Login" : "New user? Register"}
        </button>
        <button className="full-width-btn" onClick={() => setDemoMode(true)}
          style={{
            marginTop: "18px",
            background: "#31a354",
            width: "100%",
            fontWeight: 600
          }}>
          Demo Mode
        </button>
        {authError && <div style={{ color: "red" }}>{authError}</div>}
      </div>
    );
  }

  // Demo Mode To-Do List
  if (demoMode) {
    return (
      <div className="app-container">
        <h2>To-Do List (Demo Mode)</h2>
        <button className="full-width-btn"
          onClick={() => {
            setDemoMode(false);
            setTasks([]);
            setInput("");
          }}
          style={{ background: '#31a354', fontWeight: 600 }}
        >
          Exit Demo
        </button>
        <br /><br />
        <input
          type="text"
          placeholder="Add a new task"
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') addTask(); }}
        />
        <button className="full-width-btn" onClick={addTask}>Add</button>
        <ul>
          {tasks.map(task => (
            <li key={task.id}>
              <span> {task.text} </span>
              <button onClick={() => deleteTask(task.id)}>Delete</button>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  // Authenticated to-do list (regular users)
  return (
    <div className="app-container">
      <h2>To-Do List</h2>
      <button className="full-width-btn" onClick={handleLogout}>Logout</button>
      <br /><br />
      <input
        type="text"
        placeholder="Add a new task"
        value={input}
        onChange={e => setInput(e.target.value)}
        onKeyDown={e => { if (e.key === 'Enter') addTask(); }}
      />
      <button className="full-width-btn" onClick={addTask}>Add</button>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <ul>
          {tasks.map(task => (
            <li key={task.id}>
              <span> {task.text} </span>
              <button onClick={() => deleteTask(task.id)}>Delete</button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default App;
